import Vue from "vue";
import VueRouter from "vue-router";
import Auth from "@/packages/auth";
const IndexPage = () => import(/* webpackChunkName: 'auth' */ "@/views/IndexPage.vue");
const Login = () => import(/* webpackChunkName: 'auth' */ "@/views/Login.vue");
const ForgotPassword = () => import(/* webpackChunkName: 'auth' */ "@/views/ForgotPassword.vue");
const ResetPassword = () => import(/* webpackChunkName: 'resetPassword' */ "@/views/ResetPassword.vue");
const Register = () => import(/* webpackChunkName: 'register' */ "@/views/Register.vue");
const Home = () => import(/* webpackChunkName: 'dashboard' */ "@/views/Home.vue");
const SettingsHome = () => import(/* webpackChunkName: 'dashboard' */ "@/views/SettingsHome.vue");
const EditInvoice = () => import(/* webpackChunkName: 'dashboard' */ "@/views/EditInvoice.vue");
const PDFInvoice = () => import(/* webpackChunkName: 'dashboard' */ "@/views/PDFInvoice.vue");
const Dashboard = () => import(/* webpackChunkName: 'dashboard' */ "@/views/Dashboard.vue");
const Customer = () => import(/* webpackChunkName: 'dashboard' */ "@/views/Customer.vue");
const allCustomer = () => import(/* webpackChunkName: 'dashboard' */ "@/views/allCustomer.vue");
const PaymentStatus = () => import(/* webpackChunkName: 'dashboard' */ "@/views/PaymentStatus.vue");
const Billing = () => import(/* webpackChunkName: 'dashboard' */ "@/views/Billing.vue");
const Plans = () => import(/* webpackChunkName: 'plans' */ "@/views/Plans.vue");
const Settings = () => import(/* webpackChunkName: 'settings' */ "@/views/Settings.vue");
const ShopifyInstallApp = () => import(/* webpackChunkName: 'shopifyInstallApp' */ "@/views/ShopifyInstallApp.vue");
const PageNotFound = () => import(/* webpackChunkName: 'error' */ "@/views/error/PageNotFound.vue");
const Forbidden = () => import(/* webpackChunkName: 'error' */ "@/views/error/Forbidden.vue");
const InternalServerError = () => import(/* webpackChunkName: 'error' */ "@/views/error/InternalServerError.vue");
const Payment = () => import(/* webpackChunkName: 'payment' */ "@/views/Payment.vue");
const MultiplePayment = () => import(/* webpackChunkName: 'payment' */ "@/views/MultiplePayment.vue");
const StripeConnectView = () => import(/* webpackChunkName: 'stripeConnectView' */ "@/views/StripeConnectView.vue");
const NewScopesAcceptedView = () =>
  import(/* webpackChunkName: 'newScopesAcceptedView' */ "@/views/NewScopesAcceptedView.vue");

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: { requiresAuth: false },
    beforeEnter: (to, from, next) => {
      if (Auth.isAuthenticated()) {
        next({
          name: "dashboard"
        });
      } else {
        next();
      }
    }
  },
  {
    path: "/register",
    name: "register",
    component: Register,
    meta: { requiresAuth: false }
  },
  {
    path: "/billing/:token",
    name: "billing",
    component: Billing,
    meta: { requiresAuth: false }
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: ForgotPassword,
    meta: { requiresAuth: false }
  },
  {
    path: "/customer-checkout/:orderRefId",
    name: "customerCheckout",
    component: Payment,
    meta: { requiresAuth: false }
  },
  {
    path: "/payment-status/",
    name: "PaymentStatus",
    component: PaymentStatus,
    meta: { requiresAuth: false }
  },
  {
    path: "/multiple-customer-checkout/:hash",
    name: "multiplecustomerCheckout",
    component: MultiplePayment,
    meta: { requiresAuth: false }
  },
  {
    path: "/reset-password/:token",
    name: "reset-password",
    component: ResetPassword,
    meta: { requiresAuth: false }
  },
  {
    path: "/shopify-install-app",
    name: "shopifyInstallApp",
    component: ShopifyInstallApp,
    meta: { requiresAuth: false }
  },
  {
    path: "/",
    name: "IndexRoute",
    component: IndexPage
  },
  {
    path: "/ar",
    component: Home,
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: Dashboard,
        meta: { requiresAuth: true }
      },
      {
        path: "/customer/:id",
        name: "customer",
        component: Customer,
        meta: { requiresAuth: true }
      },
      {
        path: "/all-customer",
        name: "allCustomer",
        component: allCustomer,
        meta: { requiresAuth: true }
      },
      {
        path: "/plans",
        name: "plans",
        component: Plans,
        meta: { requiresAuth: true }
      },
      {
        path: "/settings",
        component: SettingsHome,
        children: [
          {
            path: "/",
            name: "settings",
            component: Settings,
            meta: { requiresAuth: true }
          },
          {
            path: "/settings/invoice",
            name: "invoice",
            component: EditInvoice,
            meta: { requiresAuth: true }
          },
          {
            path: "/settings/pdf-invoice",
            name: "pdfInvoice",
            component: PDFInvoice,
            meta: { requiresAuth: true }
          }
        ]
      }
    ]
  },
  {
    path: "/stripe-connect",
    name: "stripeConnectView",
    component: StripeConnectView,
    meta: { requiresAuth: false }
  },
  {
    path: "/additional-scopes",
    name: "newScopesAccepted",
    component: NewScopesAcceptedView,
    meta: { requiresAuth: false }
  },
  {
    path: "/403",
    name: "forbidden",
    component: Forbidden,
    meta: { requiresAuth: false }
  },
  {
    path: "/500",
    name: "internalServerError",
    component: InternalServerError,
    meta: { requiresAuth: false }
  },
  {
    path: "/404",
    name: "pageNotFound",
    component: PageNotFound,
    meta: { requiresAuth: false }
  },
  {
    path: "*",
    redirect: "/404",
    meta: { requiresAuth: false }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!Auth.isAuthenticated()) {
      next({
        name: "login"
      });
    } else {
      next(); // make sure to always call next()!
    }
  } else {
    next(); // make sure to always call next()!
  }
});

export default router;
